// application
import enMessages from './messages/en.json';
import frMessages from './messages/fr.json';


export default {
    en: {
        messages: enMessages,
        direction: 'ltr',
    },
    fr: {
        messages: frMessages,
        direction: 'ltr',
    },

};
